/** "en 2h 10m" / "hace 5m" a partir de un ISO. */
export function describeCuando(iso: string): string {
  const diff = new Date(iso).getTime() - Date.now();
  const futuro = diff >= 0;
  let s = Math.abs(diff) / 1000;
  const d = Math.floor(s / 86400);
  s -= d * 86400;
  const h = Math.floor(s / 3600);
  s -= h * 3600;
  const m = Math.floor(s / 60);
  let txt: string;
  if (d > 0) txt = `${d}d ${h}h`;
  else if (h > 0) txt = `${h}h ${m}m`;
  else txt = `${m}m`;
  return futuro ? `en ${txt}` : `hace ${txt}`;
}

/**
 * Cuándo se subió un archivo, corto (18/06/2026). Donde cabe, la vista muestra
 * además la hora con `fmtFechaCargaLarga` (en línea, nunca en un tooltip): con
 * dos cargas del mismo día es lo único que las distingue.
 *
 * OJO: es la fecha de CARGA, no la del archivo. El nombre que pone WhatsApp
 * («WhatsApp Video 2026-06-18 at 12.01.49 PM») trae la fecha en que se grabó,
 * que suele ser otra.
 */
export function fmtFechaCarga(iso: string): string {
  return new Date(iso).toLocaleDateString("es-MX", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

/** Igual que `fmtFechaCarga` pero con hora — para mostrarla en línea, con letra chica. */
export function fmtFechaCargaLarga(iso: string): string {
  return new Date(iso).toLocaleString("es-MX", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
